// client/src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Якщо колись будуть посилання типу /de/page#faq,
    // тоді не скидаємо одразу нагору, а йдемо до потрібного id.
    if (hash) {
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.replace("#", ""));
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });

      return;
    }

    // Звичайний перехід між сторінками — завжди вгору
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });

    // Додаткова страховка для різних браузерів / layout wrapper
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, hash]);

  return null;
}